import { tree2map } from '@safety/shared-utils'

/**
 * 获取组织架构树map
 * @param {Object} tree 原始组织架构树节点数组,包含顶级节点
 * @param {Boolean} trimHead map值是否去掉顶级节点
 */
export function getArchMap(tree, trimHead = true) {
  if (Object.keys(tree).length === 0) {
    return {}
  } else if (trimHead) {
    return tree2map(tree.children)
  } else {
    return tree2map([tree])
  }
}

/**
 * 获取组织架构树map, key为id, value为父节点的title数组
 */
export function getArchNameMap(tree, trimHead = true) {
  const archMap = getArchMap(tree, trimHead)
  const nameMap = {}
  for (let key in archMap) {
    nameMap[key] = archMap[key].map((it) => it.title)
  }
  return nameMap
}

export default {
  getArchMap,
  getArchNameMap
}
